const C = {
  name: "Testing",
  dimensions: { width: 31, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4616)">
    <path d="M15.002 38.0029C7.99195 38.0029 2.27195 32.4229 2.02195 25.4729C5.51195 22.3029 10.922 22.3929 14.292 25.7629C16.412 27.8929 19.212 28.9529 22.002 28.9529C24.012 28.9529 26.022 28.3929 27.792 27.2829C26.712 33.3629 21.392 38.0029 15.002 38.0029ZM11.292 12.5529L12.002 12.3329V6.00293H18.002V12.3329L18.712 12.5429C24.062 14.1329 27.812 19.0729 27.982 24.6229C24.492 27.8029 19.072 27.7129 15.702 24.3429C12.032 20.6829 6.39195 20.1829 2.18195 22.8429C3.01195 18.0429 6.52195 13.9729 11.292 12.5529ZM10.002 2.00293H19.002C19.552 2.00293 20.002 2.45293 20.002 3.00293V4.00293H11.002C10.452 4.00293 10.002 3.55293 10.002 3.00293V2.00293ZM20.002 10.8629V6.00293C21.102 6.00293 22.002 5.10293 22.002 4.00293V2.00293C22.002 0.90293 21.102 0.00292969 20.002 0.00292969H10.002C8.90195 0.00292969 8.00195 0.90293 8.00195 2.00293V4.00293C8.00195 5.10293 8.90195 6.00293 10.002 6.00293V10.8629C4.08195 12.9629 0.00195312 18.6729 0.00195312 25.0029C0.00195312 33.2729 6.73195 40.0029 15.002 40.0029C23.272 40.0029 30.002 33.2729 30.002 25.0029C30.002 18.6729 25.922 12.9629 20.002 10.8629Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4616">
    <rect width="30" height="40" fill="currentColor" transform="translate(0.00195312 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as Testing
};
